import { jsx as _jsx } from "react/jsx-runtime";
import { IconButton } from '@material-ui/core';
import { CloseOutlined } from '@material-ui/icons';
/**
 * DrawerExit component for the Drawer .
 *
 * @param {function} props.onClick - The callback function to be called when the button is clicked.
 *
 * @returns {JSX.Element} The rendered `Close` button.
 */
export function DrawerExit({ onClick }) {
    return (_jsx(IconButton, { color: 'secondary', onClick: onClick, children: _jsx(CloseOutlined, {}) }));
}
